import { findRelatedElementByClassName } from "./DOMutils";

export const getElementParentRow = (element, rowClass = "form__field") => findRelatedElementByClassName(element, "parentElement", rowClass);

const handleFormFieldFocus = (e) => {
    const parentRow = getElementParentRow(e.target);
    
    if (parentRow)
        parentRow.classList.toggle("form__field--focused");
}

const handleFormFieldFilledState = (e) => {
    const target = e.target;
    const parentRow = getElementParentRow(target);
    const actionType = target.value ? "add" : "remove";

    if(parentRow)
        parentRow.classList[actionType]("form__field--filled");
}

export const addFocusEventListener = (form) => ["focusin", "focusout"].forEach(event => form.addEventListener(event, handleFormFieldFocus));

export const addChangeEventListener = (form) => form.addEventListener("change", handleFormFieldFilledState);